import React, { memo, useMemo, useState } from 'react';
import { Proposal } from '../types';
import { BlockContainer } from '../BlockContainer';
import { useHistory } from '@core/router';
import classNames from 'classnames';
import { formGroup, formControl, FormDataType, formArray } from '@core/utils/form';
import { useObservable } from '@core/utils/hooks/rxjs';
import { useConfigureBlock } from '@modules/proposal/hooks';
import { Container } from 'reactstrap';
import { useProposalContext, useProposalDataContext } from '@modules/proposal/ProposalBuilderPage';
import { FormInput } from '@core/components/form';
import { R } from '@core/utils/r';
import { BlockTemplateBlockSettings } from './BlockTemplateBlockSettings';
import './index.scss';

function defineSignerBlockItemForm(terms: number) {
  return formGroup({
    email: formControl<string>({}),
  });
}

function defineSignerBlockForm(terms: number) {
  return formGroup({
    items: formArray(() => defineSignerBlockItemForm(terms)),
  });
}
export type SignerWidgetItemFormData = FormDataType<typeof defineSignerBlockItemForm>;
export type SignerWidgetFormData = FormDataType<typeof defineSignerBlockForm>;
export type SignerWidgetForm = ReturnType<typeof defineSignerBlockForm>;

export enum BlockTemplateBlockVariation {
  blockTemplate = 'Block Template',
}

export const BlockTemplateBlock = memo((props: Proposal.BlockProps<BlockTemplateBlockVariation>) => {
  const { variation, preview, editable } = props;
  const [init, setInit] = useState(false);
  const [currentSignee, setCurrentSignee] = useState(0);
  const proposal = useProposalContext();
  const proposalData = useProposalDataContext();
  const [isAccepted, setIsAccepted] = useState(true);
  const history = useHistory();
  const signee = useMemo(() => {
    if (proposalData?.signee) {
      return proposalData.signee;
    } else {
      return null;
    }
  }, [proposalData]);

  const mainProposalForm = useMemo(() => {
    if (proposal) return proposal.form;
  }, [proposal]);
  const mainFormValues = useObservable(mainProposalForm && mainProposalForm.value$);
  const termsValue = useObservable(proposal?.form.controls.terms.value$, '');
  const productValues = useObservable(proposal?.form.controls.products.value$, []);
  const termsOccurance = useMemo(() => R.occurrences(termsValue || '', '[]'), [termsValue]);
  const form = useMemo(() => defineSignerBlockForm(termsOccurance), [termsOccurance]);

  useConfigureBlock({ props, form, contentComponent: BlockTemplateBlockSettings, contentProps: { form, terms: proposal?.form.controls.terms } });

  return (
    <BlockContainer
      className={classNames('block-signer', variation, preview)}
      isSection={props.isSection}
      sectionTitle={props.sectionTitle}
      fullWidth={false}
      editable={editable}
    >
      {/* <Container> */}
      <div style={{ display: 'flex' }}>
        {(props.editable || props.preview) && (
          <div className="signer-centered" style={{ flex: 1 }}>
            <FormInput control={formControl({ placeholder: 'John Smith' })} editable={false} disabled={true} />
          </div>
        )}
      </div>
      {/* </Container> */}
    </BlockContainer>
  );
});
